import styled from 'styled-components';
import AlertBar from './AlertBar';
import { colorSchema } from 'utils/style';

export default styled(AlertBar)`
  .alert-bar {
    align-items: center;
    background: ${colorSchema('primary900')};
    color: ${colorSchema('white')};
    display: flex;
    padding: 1.6rem;
    justify-content: space-between;

    &__body {
      align-items: center;
      display: flex;
    }

    &__icon {
      margin-right: 1.6rem;
      svg {
        fill: ${colorSchema('white')};
      }
    }

    &__text {
      font-size: 1.6rem;
      font-weight: 500;
      line-height: 1.31;
    }

    &__close {
      background: none;
      border: 0;
      cursor: pointer;

      svg {
        fill: ${colorSchema('white')};
      }
    }
  }
`;
